module.exports = __webpack_public_path__ + "assets/a99c6de1c77674c1efc143e2dbe3c21b.jpg";